export const CIUDADESALL = [
    { id: 1, nombre: "Bogotá D.C.", id_departamento: 5 },
    { id: 2, nombre: "Medellín", id_departamento: 2 },
    { id: 3, nombre: "Cali", id_departamento: 31 },
    { id: 4, nombre: "Barranquilla", id_departamento: 4 },
    { id: 5, nombre: "Cartagena", id_departamento: 6 },
    { id: 6, nombre: "Bucaramanga", id_departamento: 28 },
    { id: 7, nombre: "Cúcuta", id_departamento: 23 },
    { id: 8, nombre: "Pereira", id_departamento: 26 },
    { id: 9, nombre: "Santa Marta", id_departamento: 20 },
    { id: 10, nombre: "Manizales", id_departamento: 8 },
    { id: 11, nombre: "Ibagué", id_departamento: 30 },
    { id: 12, nombre: "Neiva", id_departamento: 18 },
    { id: 13, nombre: "Valledupar", id_departamento: 12 },
    { id: 14, nombre: "Sincelejo", id_departamento: 29 },
    { id: 15, nombre: "Quibdó", id_departamento: 13 },
    { id: 16, nombre: "Tunja", id_departamento: 7 },
    { id: 17, nombre: "Villavicencio", id_departamento: 21 },
    { id: 18, nombre: "Riohacha", id_departamento: 19 },
    { id: 19, nombre: "Popayán", id_departamento: 11 },
    { id: 20, nombre: "Tuluá", id_departamento: 31 },
    { id: 21, nombre: "Barrancabermeja", id_departamento: 28 },
    { id: 22, nombre: "Pasto", id_departamento: 22 },
    { id: 23, nombre: "Sogamoso", id_departamento: 7 },
    { id: 24, nombre: "Yopal", id_departamento: 10 },
    { id: 25, nombre: "Montería", id_departamento: 14 },
    { id: 26, nombre: "Caldas", id_departamento: 2 },
    { id: 27, nombre: "San Andrés", id_departamento: 27 },
    { id: 28, nombre: "Florencia", id_departamento: 9 },
    { id: 29, nombre: "Armenia", id_departamento:25 },
    { id: 30, nombre: "Arauca", id_departamento:3 },
    { id: 31, nombre: "Mocoa", id_departamento:24 },
    { id: 32, nombre: "Leticia", id_departamento:1 },
    { id: 33, nombre: "Inírida", id_departamento:16 },
    { id: 34, nombre: "San josé del guaviare", id_departamento:17 },
    { id: 35, nombre: "Mitú", id_departamento:32 },
    { id: 36, nombre: "Puerto carreño", id_departamento:33 },
]